import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Button } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_BUTTON_LABEL } from './MenuFileButtons.constants';
import { resolveButtonLabel } from './MenuFileButtons.utils';
import OutboundLink from '../../atoms/OutboundLink';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import { ObjectPropsPropType } from '../../services/proptypes';
import './MenuFileButtons.css';
var defaultProps = {
  button: {},
  buttonLabel: DEFAULT_BUTTON_LABEL
};
export default function MenuFileButtons(_ref) {
  var files = _ref.files,
    button = _ref.button,
    buttonLabel = _ref.buttonLabel;
  if (_isEmpty(files)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, files.map(function (_ref2) {
    var url = _ref2.url,
      filename = _ref2.filename;
    var finalLabel = resolveButtonLabel(filename, buttonLabel);
    return /*#__PURE__*/React.createElement(Button, _extends({}, button, {
      content: finalLabel,
      className: "fc-menu-file-button",
      key: "".concat(filename, "_").concat(url),
      as: function as(semProps) {
        return /*#__PURE__*/React.createElement(OutboundLink, _extends({}, semProps, {
          to: url,
          label: buttonLabel
        }));
      },
      event: {
        category: EVENT_CATEGORIES.SERVICES_EVENT_CATEGORY,
        action: EVENT_ACTIONS.SERVICES_VIEW_ALL_SERVICES_EVENT_ACTION,
        label: finalLabel
      }
    }));
  }));
}
MenuFileButtons.defaultProps = defaultProps;